import { useAppContext } from "@/contexts/AppContext";

export type NavSidebarMode = "expanded" | "collapsed";

export function useNavSidebarState() {
  const { navSidebarMode, setNavSidebarMode, toggleNavSidebarMode } = useAppContext();

  return {
    mode: navSidebarMode,
    setMode: setNavSidebarMode,
    toggle: toggleNavSidebarMode,
  } as const;
}
